import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const InvoiceErrorDomesticStepConfig: StepConfig = {
    type: FormType.INVOICE_ERROR_DOMESTIC
};
